var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9831 10.7002C21.9831 17.7002 12.9831 23.7002 12.9831 23.7002C12.9831 23.7002 3.98306 17.7002 3.98306 10.7002C3.98306 8.31325 4.93127 6.02406 6.6191 4.33623C8.30693 2.64841 10.5961 1.7002 12.9831 1.7002C15.37 1.7002 17.6592 2.64841 19.347 4.33623C21.0349 6.02406 21.9831 8.31325 21.9831 10.7002Z",
    stroke: "#00C9C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9831 13.7002C14.6399 13.7002 15.9831 12.357 15.9831 10.7002C15.9831 9.04334 14.6399 7.7002 12.9831 7.7002C11.3262 7.7002 9.98306 9.04334 9.98306 10.7002C9.98306 12.357 11.3262 13.7002 12.9831 13.7002Z",
    stroke: "#00C9C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.983063 0.700195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsIcon);
export default __webpack_public_path__ + "static/media/maps-icon.67ca72c34389792b4b03efb722c2efd2.svg";
export { ForwardRef as ReactComponent };